module.exports = __webpack_public_path__ + "img/linkedin-in-brands.7ab05450.svg";